module.exports = "https://web-assets.ifttt.com/packs/media/icons/updated-9a9d9a6d.png";